module.exports = __webpack_public_path__ + "static/media/img-1.3ce3b98b.png";